import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { validateVerticalPosition } from '@angular/cdk/overlay';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { UtilService } from 'src/app/shared/services/util.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { utils } from 'protractor';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
    selector: 'app-guardar-compensaciones',
    templateUrl: './guardar-compensaciones.component.html',
    styleUrls: ['./../plan-compensatorio.component.scss']
})
export class GuardarCompensacionComponent implements OnInit {

    public modalOptionsGuardar: ConfirmationModalOptions;
    public infoCompensatorio: PlanCompensatorioModel;
    public datosCompensacion: any;
    public valorChekboxDiario: boolean;
    public valorChekboxSabado: boolean;
    public valorChekboxMixto: boolean;
    public consultaEstados: string[];
    public banderaInformacion: boolean;
    festivos = [];

    constructor(
        private router: Router,
        public route: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private global: GlobalService,
        private alertService: AlertService,
        private utilService: UtilService
    ) {
        this.infoCompensatorio = new PlanCompensatorioModel();
        this.infoCompensatorio.listaTurnos = [];
        this.valorChekboxDiario = false;
        this.valorChekboxSabado = false;
        this.valorChekboxMixto = false;
        this.banderaInformacion = false;
    }

    ngOnInit() {
        this.consultarFestivos();
        this.modalOptionsGuardar = new ConfirmationModalOptions(
            'Confirmación',
            ConstantesService.MSJ_CONF_GUARDAR_COMPENSACION,
            'SI', 'NO', 'fa fa-save', true, false, 'Guardar', null, 'btn btnGuardar btn-secondary');
        const datosCompensacion = this.global.zonaCompartida[VariablesZonaCompartida.DATOS_COMPENSACION];
        if (datosCompensacion) {
            this.datosCompensacion = datosCompensacion;
        } else {
            this.banderaInformacion = true;
        }
        if (this.datosCompensacion) {
            this.consultarCompensacion();
        }

    }

    /**
     * Método que valida las fechas con los festivos
     */
    public consultarFestivos() {
        const serviceProvider = 'consultarFestivos';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.festivos = data;
            }, err => {
                this.cathException('No es posible Obtener los festivos');
            });
    }


    validarFestivos(){
        for (const festivo of this.festivos) {
            if ((festivo && this.infoCompensatorio.fechaInicial && this.infoCompensatorio.fechaFinal)
                && (this.utilService.setearFinFecha(new Date(festivo)).getTime() === this.utilService.setearFinFecha(new Date(this.infoCompensatorio.fechaInicial)).getTime()
                    || this.utilService.setearFinFecha(new Date(festivo)).getTime() === this.utilService.setearFinFecha(new Date(this.infoCompensatorio.fechaFinal)).getTime())) {
                this.cathException('Las fechas de compensación no pueden ser días festivos, por favor verifique');
                return false;
            }
        }
        return true;
    }


    /**
     * Metodo que se realiza al verificar si el usuario selecciono SI o NO al guardar la
     * información
     * @param event Contiene la confirmacion SI o NO
     */
    getConfirmationGuardar(confirmacion: any) {
        const isFestivo = !this.validarFestivos();
        if (isFestivo) {
            return false;
        }

        if (typeof this.infoCompensatorio.fechaFinal === 'string') {
            this.infoCompensatorio.fechaFinal = new Date(this.infoCompensatorio.fechaFinal);
        }
        if (typeof this.infoCompensatorio.fechaInicial === 'string') {
            this.infoCompensatorio.fechaInicial = new Date(this.infoCompensatorio.fechaInicial);
        }

        if (this.infoCompensatorio.fechaFinal.getTime() < this.infoCompensatorio.fechaInicial.getTime()) {
            this.cathException('La fecha inicial de compensación no puede ser mayor a la fecha final');
            return false;
        }

        if (confirmacion[0]) {
            this.spinner.show();
            let serviceProvider: string;
            serviceProvider = 'guardarInformacionCompensaciones';
            const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
                this.urlService.hostAPI_FUNCIONARIOS);
            this.global.post(url, this.infoCompensatorio).subscribe(
                data => {
                    this.alertService.generateAlertSuccess(data, 'Exitoso');
                    this.spinner.hide();
                }, err => {
                    this.utilService.cathException(err, this.alertService, this.spinner);
                }
            );
        }
    }

    /**
     * Metodo que realiza la consulta de Compensacion seleccionada
     */
    consultarCompensacion() {
        this.spinner.show();
        let serviceProvider: string;
        serviceProvider = 'consultarCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=idPlanCompensacion', this.datosCompensacion.id]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.infoCompensatorio = data[0];
                this.consultarTurnosCompensacion();
            }, err => {
                if (err.status === 500) {
                    this.cathException(err.error.message);
                } else {
                    this.cathException('No es posible Obtener la información del plan de compensación');
                }
            }
        );
    }

    /**
     * Metodo que consulta los turno existente para el plan de compensacion
     * seleccionado
     */
    consultarTurnosCompensacion() {
        let serviceProvider: string;
        serviceProvider = 'consultarTurnosCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=idPlanCompensacion', this.datosCompensacion.id]);
        let url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        url = url + '&orderBy=ordenTurno$ASC';
        this.global.getGenerico(url).subscribe(
            data => {
                this.infoCompensatorio.listaTurnos = data;
                this.banderaInformacion = true;
                this.mostrarChecboxConsultados();
                this.validacion();
                this.spinner.hide();
            }, err => {
                if (err.status === 500) {
                    this.cathException(err.error.message);
                } else {
                    this.cathException('No es posible Obtener la información de los Turnos');
                }
            }
        );
    }

    /**
     * Metodo que muestra los checbox consultados
     */
    mostrarChecboxConsultados() {
        if (this.infoCompensatorio.horarioDiario === 'SI') {
            this.valorChekboxDiario = true;
        } else {
            this.valorChekboxDiario = false;
        }
        if (this.infoCompensatorio.horarioSabados === 'SI') {
            this.valorChekboxSabado = true;
        } else {
            this.valorChekboxSabado = false;
        }
        if (this.infoCompensatorio.horarioMixto === 'SI') {
            this.valorChekboxMixto = true;
        } else {
            this.valorChekboxMixto = false;
        }
    }

    /**
     * Metodo que indica que checkbox fue seleccionado
     */
    seleccionHorario() {
        if (this.valorChekboxDiario) {
            this.infoCompensatorio.horarioDiario = 'SI';
        } else {
            this.infoCompensatorio.horarioDiario = 'NO';
        }
        if (this.valorChekboxSabado) {
            this.infoCompensatorio.horarioSabados = 'SI';
        } else {
            this.infoCompensatorio.horarioSabados = 'NO';
        }
        if (this.valorChekboxMixto) {
            this.infoCompensatorio.horarioMixto = 'SI';
        } else {
            this.infoCompensatorio.horarioMixto = 'NO';
        }

        this.validacion();
    }

    /**
     * Metodo que realiza la validacion de campos obligatorios
     */
    validacion() {
        if (this.validarInformacionCompensacion() && this.validarInformacionInscripcion() &&
            this.validarInformacionTurnos() && this.validarHorarioObservaciones()) {
                this.modalOptionsGuardar.disabled = false;
        } else {
            this.modalOptionsGuardar.disabled = true;
        }
    }

    /**
     * Metodo que validara los campos de informacion compensación
     */
    validarInformacionCompensacion() {
        if (this.utilService.validarCamposObligatorios(this.infoCompensatorio.nombrePlanCompensacion) &&
            this.utilService.validarCamposObligatorios(this.infoCompensatorio.fechaInicial) &&
            this.utilService.validarCamposObligatorios(this.infoCompensatorio.fechaFinal) &&
            this.utilService.validarCamposObligatorios(this.infoCompensatorio.horasCompensacion) &&
            this.utilService.validarCamposObligatorios(this.infoCompensatorio.fechaFinalRepConsolidado) &&
            this.utilService.validarCamposObligatorios(this.infoCompensatorio.estado)) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Metodo que validará la información de la inscripción
     */
    validarInformacionInscripcion() {
        if (this.utilService.validarCamposObligatorios(this.infoCompensatorio.fechaInicialInscripcion) &&
            this.utilService.validarCamposObligatorios(this.infoCompensatorio.fechaFinalInscripcion) &&
            this.utilService.validarCamposObligatorios(this.infoCompensatorio.fechaInicialAutorizacion) &&
            this.utilService.validarCamposObligatorios(this.infoCompensatorio.fechaFinalAutorizacion)) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Metodo que valida la información de los turnos
     */
    validarInformacionTurnos() {
        for (const turnos of this.infoCompensatorio.listaTurnos) {
            if (this.utilService.validarCamposObligatorios(turnos.fechaInicial) &&
                this.utilService.validarCamposObligatorios(turnos.fechaFinal) &&
                this.utilService.validarCamposObligatorios(turnos.nombre) &&
                turnos.estado === DominiosService.TURNO_COMPENSACION_ACTIVO) {
                return true;
            } else {
                return false;
            }
        }
    }

    /**
     * Metodo que valida que almenos un checkbox se encuentre seleccionado
     */
    validarHorarioObservaciones() {
        if (this.infoCompensatorio.horarioDiario === 'SI' || this.infoCompensatorio.horarioSabados === 'SI' ||
            this.infoCompensatorio.horarioMixto === 'SI') {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Metodo Volver que los enviara a la pantalla principal de plan compensatorio
     */
    regresarCompensaciones() {
        this.global.zonaCompartida[VariablesZonaCompartida.DATOS_COMPENSACION] = undefined;
        this.router.navigate(['/main/plan-compensatorio']);
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
